import { Amplify } from "aws-amplify";
import config from "@/config";

let configured = false;

/**
 * Configure Amplify Auth once at app boot.
 */
export function configureCognito(): void {
  if (configured) return;

  const { USER_POOL_ID, CLIENT_ID } = config.COGNITO;
  if (!USER_POOL_ID || !CLIENT_ID) {
    console.warn(
      "Cognito is not configured. Set VITE_COGNITO_USER_POOL_ID and VITE_COGNITO_CLIENT_ID."
    );
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: USER_POOL_ID,
        userPoolClientId: CLIENT_ID,
        loginWith: {
          email: true,
        },
      },
    },
  });

  configured = true;
}
